import { updateItem } from '@directus/sdk';
import { useMutation } from '@tanstack/react-query';

import type { Event } from '../../../../types/DirectusSchema';
import { directusClient } from '../../services/directusClient/directusClient.ts';
import { tanstackQueryClient } from '../../services/tanstackQueryClient.ts';
import { usePromoterItemQuery } from '../promoter/usePromoterItemQuery.ts';

export const useEventsItemUpdateMutation = (key?: string) => {
  const { data } = usePromoterItemQuery();

  return useMutation({
    mutationFn: async (updateData: Partial<Event>) => {
      if (!key) throw new Error('Event ID is required');
      if (!data?.id) throw new Error('Promoter data not loaded');
      await directusClient.request(updateItem('events', key, { ...updateData, promoter: data.id }));
    },
    onSuccess: async () => {
      await tanstackQueryClient.invalidateQueries({
        queryKey: ['events', key],
      });
    },
  });
};
